// Copyright (c) 2016 Deere & Company

import {
    updateKeyValueSelectionList,
    updateList
} from '../../../shared/services/list-selections';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import actions from '../../../user/actions-list';
import {getDefaultState} from '../state/';

const updateAllClaimsStatus = (state, action) => {

    const toggledStatuses = state.settings.claims.status.selectedStatuses.length ?
        [] :
        action.statusList;

    return User.update(state, {
        settings: {
            claims: {
                status: {
                    selectedStatuses: {
                        $set: toggledStatuses
                    }
                }
            }
        }
    });

};

const updateAllClaimTypes = (state, action) => {

    const toggledClaimTypes = state.settings.dbs.claimTypes.selectedClaimTypes.length ?
        [] :
        action.allowedClaimTypes;

    return User.update(state, {
        settings: {
            dbs: {
                claimTypes: {
                    selectedClaimTypes: {
                        $set: toggledClaimTypes
                    }
                }
            }
        }
    });

};

const updateAllDealerAccounts = (state, action) => {

    const toggledStatuses = state.settings.dealer.accounts.selectedAccounts.length ?
        [] :
        action.dealers;

    return User.update(state, {
        settings: {
            dealer: {
                accounts: {
                    selectedAccounts: {
                        $set: toggledStatuses
                    }
                }
            }
        }
    });

};

const updateAllPartReturnsStatus = (state, action) => {

    const toggledStatuses = state.settings.partReturns.status.selectedStatuses.length ?
        [] :
        action.statusList;

    return User.update(state, {
        settings: {
            partReturns: {
                status: {
                    selectedStatuses: {
                        $set: toggledStatuses
                    }
                }
            }
        }
    });

};

const updateClaimsNumberOfDays = (state, action) =>
    User.update(state, {
        settings: {
            claims: {
                numberOfDays: {
                    $set: action.numberOfDays
                }
            }
        }
    });

const updateClaimsStatus = (state, action) =>
    User.update(state, {
        settings: {
            claims: {
                status: {
                    selectedStatuses: {
                        $set: updateKeyValueSelectionList(
                            action.status,
                            action.isSelected,
                            state.settings.claims.status.selectedStatuses
                        )
                    }
                }
            }
        }
    });

const updateClaimType = (state, action) =>
    User.update(state, {
        settings: {
            dbs: {
                claimTypes: {
                    selectedClaimTypes: {
                        $set: updateKeyValueSelectionList(
                            action.claimType,
                            action.isSelected,
                            state.settings.dbs.claimTypes.selectedClaimTypes
                        )
                    }
                }
            }
        }
    });

const updateCsvSeparator = (state, action) =>
    User.update(state, {
        settings: {
            general: {
                csvSeparator: {
                    $merge: {
                        key: action.csvSeparator.key,
                        value: action.csvSeparator.value
                    }
                }
            }
        }
    });

const updateDbsAutoSubmit = (state, action) =>
    User.update(state, {
        settings: {
            dbs: {
                autoSubmit: {
                    $merge: {
                        key: action.autoSubmit.key,
                        value: action.autoSubmit.value
                    }
                }
            }
        }
    });

const updateDealerAccounts = (state, action) =>
    User.update(state, {
        settings: {
            dealer: {
                accounts: {
                    selectedAccounts: {
                        $set: updateList(
                            action.dealer,
                            action.isSelected,
                            'account',
                            state.settings.dealer.accounts.selectedAccounts
                        )
                    }
                }
            }
        }
    });

const updateDealerDisplayFormat = (state, action) =>
    User.update(state, {
        settings: {
            dealer: {
                displayFormat: {
                    $merge: {
                        key: action.displayFormat.key,
                        value: action.displayFormat.value
                    }
                }
            }
        }
    });

const updateGeneralDateFormat = (state, action) =>
    User.update(state, {
        settings: {
            general: {
                dateFormat: {
                    $merge: {
                        key: action.dateFormat.key,
                        value: action.dateFormat.value
                    }
                }
            }
        }
    });

const updateGeneralDecimalFormat = (state, action) =>
    User.update(state, {
        settings: {
            general: {
                decimalFormat: {
                    $merge: {
                        key: action.decimalFormat.key,
                        value: action.decimalFormat.value
                    }
                }
            }
        }
    });

const updateGeneralTimeZone = (state, action) =>
    User.update(state, {
        settings: {
            general: {
                timeZone: {
                    $merge: {
                        key: action.timeZone.key,
                        value: action.timeZone.value
                    }
                }
            }
        }
    });

const updateLanguagePrimaryLanguage = (state, action) =>
    User.update(state, {
        settings: {
            language: {
                primaryLanguage: {
                    $merge: {
                        key: action.primaryLanguage.key,
                        value: action.primaryLanguage.value
                    }
                }
            }
        }
    });

const updatePartReturnsNumberOfDays = (state, action) =>
    User.update(state, {
        settings: {
            partReturns: {
                numberOfDays: {
                    $set: action.numberOfDays
                }
            }
        }
    });

const updatePartReturnsStatus = (state, action) =>
    User.update(state, {
        settings: {
            partReturns: {
                status: {
                    selectedStatuses: {
                        $set: updateKeyValueSelectionList(
                            action.status,
                            action.isSelected,
                            state.settings.partReturns.status.selectedStatuses
                        )
                    }
                }
            }
        }
    });

const updatePrimaryLanguageKey = (state, action) =>
    User.update(state, {
        settings: {
            language: {
                primaryLanguage: {
                    $merge: {
                        key: action.key
                    }
                }
            }
        }
    });

const updateRedIndicator = (state, action) =>
    User.update(state, {
        settings: {
            reimbursementSummary: {
                reimbursedPercentIndicator: {
                    red: {
                        $set: action.value
                    }
                }
            }
        }
    });

const updateYellowIndicator = (state, action) =>
    User.update(state, {
        settings: {
            reimbursementSummary: {
                reimbursedPercentIndicator: {
                    yellow: {
                        $set: action.value
                    }
                }
            }
        }
    });

const updateThemePreferredTheme = (state, action) =>
    User.update(state, {
        settings: {
            theme: {
                preferredTheme: {
                    $merge: {
                        key: action.preferredTheme.key,
                        value: action.preferredTheme.value
                    }
                }
            }
        }
    });

const updateUser = (state, action) =>
    User.update(state, {
        $set: action.data
    });

export default (state = getDefaultState().details, action) => {

    const actionTypes = {
        [actions.UPDATE_USER_PREFERENCES_ALL_CLAIMS_STATUS]: updateAllClaimsStatus,
        [actions.UPDATE_USER_PREFERENCES_ALL_CLAIM_TYPES]: updateAllClaimTypes,
        [actions.UPDATE_USER_PREFERENCES_ALL_DEALER_ACCOUNTS]: updateAllDealerAccounts,
        [actions.UPDATE_USER_PREFERENCES_ALL_PART_RETURNS_STATUS]: updateAllPartReturnsStatus,
        [actions.UPDATE_USER_PREFERENCES_CLAIMS_NUMBER_OF_DAYS]: updateClaimsNumberOfDays,
        [actions.UPDATE_USER_PREFERENCES_CLAIMS_STATUS]: updateClaimsStatus,
        [actions.UPDATE_USER_PREFERENCES_CLAIM_TYPE]: updateClaimType,
        [actions.UPDATE_USER_PREFERENCES_CSV_SEPARATOR]: updateCsvSeparator,
        [actions.UPDATE_USER_PREFERENCES_DBS_AUTO_SUBMIT]: updateDbsAutoSubmit,
        [actions.UPDATE_USER_PREFERENCES_DEALER_ACCOUNTS]: updateDealerAccounts,
        [actions.UPDATE_USER_PREFERENCES_DEALER_DISPLAY_FORMAT]: updateDealerDisplayFormat,
        [actions.UPDATE_USER_PREFERENCES_GENERAL_DATE_FORMAT]: updateGeneralDateFormat,
        [actions.UPDATE_USER_PREFERENCES_GENERAL_DECIMAL_FORMAT]: updateGeneralDecimalFormat,
        [actions.UPDATE_USER_PREFERENCES_GENERAL_TIME_ZONE]: updateGeneralTimeZone,
        [actions.UPDATE_USER_PREFERENCES_LANGUAGE_PRIMARY_LANGUAGE]: updateLanguagePrimaryLanguage,
        [actions.UPDATE_USER_PREFERENCES_PART_RETURNS_NUMBER_OF_DAYS]: updatePartReturnsNumberOfDays,
        [actions.UPDATE_USER_PREFERENCES_PART_RETURNS_STATUS]: updatePartReturnsStatus,
        [actions.UPDATE_USER_PREFERENCES_PRIMARY_LANGUAGE_KEY]: updatePrimaryLanguageKey,
        [actions.UPDATE_USER_PREFERENCES_REIMBURSEMENT_RED_INDICATOR]: updateRedIndicator,
        [actions.UPDATE_USER_PREFERENCES_REIMBURSEMENT_YELLOW_INDICATOR]: updateYellowIndicator,
        [actions.UPDATE_USER_PREFERENCES_THEME_PREFERRED_THEME]: updateThemePreferredTheme,
        [actions.UPDATE_USER_PREFERENCES_SUCCESS]: updateUser

    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/user/shared/reducers/user.js